module.exports = __webpack_public_path__ + "assets/img/title-331b1441.png";